module.exports = __webpack_public_path__ + "24d99e97ab487a059cffa5a275fa0c0a.pdf";